export function useApiUrl(): string {
  return process.env.API_URL || 'http://localhost:4000'
  //return process.env.API_URL || 'http://www.hexapla.org'
}
